import { Invariants } from '@commandDrivenStateEngine/core/invariants';
import { OnboardingWizardState } from './state';
import { OnboardingWizardCommand } from './commands';

/**
 * The wizard's own state is flow bookkeeping — screen, selection, wait status.
 * The privileged actions it triggers (connecting a channel, starting an import)
 * are commands on OTHER domains and are gated there, against the real
 * capability, by those domains' own `canApply` + the auth-attaching dispatch
 * wrapper. Duplicating a gate here would be a second, weaker copy of a rule
 * that already exists at the boundary that matters.
 */
export const invariants: Invariants<OnboardingWizardState, OnboardingWizardCommand> = {
  normalize: ( state ) => state,
  canApply: () => true,
  validate: () => null
};
